import { Typography } from '@mui/material';
import React from 'react';
import type { LevelTableColumn } from 'redesign';
import { ContextMenuButton } from 'redesign';
import {
  WorkflowsCellProp,
  WorkflowsColumnDefinition,
  WorkflowsTableOptions,
} from './workflows-table.types';

export const getWorkflowColumnDefinition: () => LevelTableColumn<
  WorkflowsColumnDefinition,
  WorkflowsTableOptions
>[] = () => {
  const workflowName: LevelTableColumn<WorkflowsColumnDefinition, WorkflowsTableOptions> = {
    Header: () => <Header>Naam</Header>,
    accessor: 'workflowName',
    Cell: NameCell,
  };

  const actions: LevelTableColumn<WorkflowsColumnDefinition, WorkflowsTableOptions> = {
    Header: () => <Header>Acties</Header>,
    accessor: 'actions',
    width: '150px',
    Cell: ActionCell,
  };

  return [workflowName, actions];
};

const Header = ({ children }: React.PropsWithChildren<unknown>) => (
  <Typography variant="body2" style={{ fontWeight: 'bold' }}>
    {children}
  </Typography>
);

const NameCell = (cell: WorkflowsCellProp<'workflowName'>) => {
  return (
    <Typography variant="body1" noWrap>
      {cell.value}
    </Typography>
  );
};

const ActionCell = (cell: WorkflowsCellProp<'actions'>) => {
  const actions = cell.getRowActions(cell.value.workflowId);
  const isArchived = cell.row.original.isArchived;
  return <ContextMenuButton disabled={isArchived}>{actions}</ContextMenuButton>;
};
